<div class="project-logbook-properties">
  <!-- FILE EVENT PROPERTIES -->
  <!-- TODO: when file comes with active property: || !properties.file.active -->
  <div class="files" *ngIf="event.type == FILE_ADDED || event.type == FILE_REMOVED" 
      [ngClass]="{'removed': (event.type == FILE_REMOVED || !properties.file.active)}">
    <core-files-list-notes-item
      [file]="properties.file"
      [notes]="notes"
      [menu]="menu"
      (menuClick)="onMenuClick($event)"
      (actionClick)="onClickPreview($event)"
      (iconDownloadClick)="onActionDownloadClick($event)"
    ></core-files-list-notes-item>
  </div>
    <!-- ASSIGNED EVENT PROPERTIES -->
  <div class="assigned" *ngIf="event.type == ASSIGNED">

    <span *ngIf="properties.assigned.user == null else userassignee"><strong>No user assigned</strong></span>
    <ng-template #userassignee>
      <core-helper-box-header-user-date 
      [user]="properties.assigned.user"
      [preText]="'Assigned to'"
    ></core-helper-box-header-user-date>
    </ng-template>
    
  </div>
    <!-- LABELS EVENT PROPERTIES -->
  <div class="label" *ngIf="event.type == LABEL_ADDED || event.type == LABEL_REMOVED">
    <core-label [label]="properties.label"></core-label>
  </div>
    <!-- DUE DATE EVENT PROPERTIES -->
  <div class="due-date" *ngIf="event.type == DUE_DATE">
    <span>{{properties.due_date.date | date:'dd MMM yyyy' }}</span>
  </div>
    <!-- ASSIGNED EVENT PROPERTIES -->
  <div class="stages" *ngIf="event.type == STAGE_UPDATED">
    <project-details-helpers-stages-transition [origin]="properties.origin" [status]="properties.status"></project-details-helpers-stages-transition>
  </div>
  <!-- MESSAGES EVENT PROPERTIES MESSAGE_REMOVED-->
  <div class="message" *ngIf="event.type == MESSAGE_ADDED || event.type == MESSAGE_REMOVED">
    <core-message
      [message]="properties.message"
      [notesActionText]="'See Notes'"
      [notesActionStyle]="'see-notes'"
      [canCreateNotes]="false"
      [delete]="false"
      [prefixUrl]="messagePrefixUrl"
    ></core-message>
  </div>
  <!-- ADDED EVENT PROPERTIES -->
  <div class="project-added" *ngIf="event.type == PROJECT_ADDED">
    <!-- First general info of the project-->
    <div class="default-text" [innerHTML]="properties.request.info">{{properties.request.info}}</div>
  </div>
  <!-- ARTWORK ADDED EVENT PROPERTIES -->
  <div class="artwork-added" *ngIf="event.type == ARTWORK_ADDED">
    <core-versions-summary-box
        [version]="properties.version"
        [menu]="menuVersion"
        [uploaded]="true"
        [feedbacks]="feedbacks"
        (menuClick)="onVersionMenuClick($event)"
        (actionFileClick)="onClickVersionPreview($event)"
    ></core-versions-summary-box>
  </div>
  <!-- GENERAL INFO UPDATED EVENT PROPERTIES -->
  <div class="project-information-changed" *ngIf="event.type == INFO_UPDATED">
    <div class="default-text" [innerHTML]="properties.information.content">{{properties.information.content}}</div>
  </div>

  <!-- FORM SUBMISSION VALUE ADDED -->
  <div class="project-form-submission-added" *ngIf="event.type == FORM_SUBMISSION_ADDED">
    <div class="form-name"><em>On form:</em> <span>{{properties.request_custom_form_submission?.custom_form.name}}</span></div>
    <div class="form-fields-values" *ngIf="properties.request_custom_form_submission?.submissions?.length > 0; else noDataSubmitted">
      <ul class="fields-list">
          <!-- place in the li the new component for form  dynamic fields where each field will be loaded in html -->
          <li class="fields-list-item"
              *ngFor="let fieldSubmission of properties.request_custom_form_submission.submissions | sortBy : 'fieldSubmission.field.position' : 'asc' ">
              <!-- <span> {{fieldSubmission.field.type}}</span> -->
              <custom-forms-dynamic-view-field-host
                  [fieldSubmission]="fieldSubmission"
              ></custom-forms-dynamic-view-field-host>
          </li>
      </ul>
    </div>
    <ng-template #noDataSubmitted>
      <p>Event has no data yet.</p></ng-template>
  </div>

</div>
